import { useState } from 'react';
import { Card, FlexColumn, Tab, Tabs } from '@elementary/common-ui/components';
import UsageLeaderboard from './UsageLeaderboard';
import SessionsList from './SessionsList';
import { LeaderboardRow, SessionRow } from './types';

type UsageTab = 'leaderboard' | 'sessions';

type Props = {
  leaderboard: LeaderboardRow[];
  sessions: SessionRow[];
};

const UsageCard = ({ leaderboard, sessions }: Props) => {
  const [tab, setTab] = useState<UsageTab>('leaderboard');

  return (
    <Card>
      <FlexColumn sx={{ gap: 2, width: '100%' }}>
        <Tabs value={tab} onChange={(_, value: UsageTab) => setTab(value)}>
          <Tab value="leaderboard" label="Leaderboard" />
          <Tab value="sessions" label="Sessions" />
        </Tabs>
        {tab === 'leaderboard' ? (
          <UsageLeaderboard entries={leaderboard} />
        ) : (
          <SessionsList sessions={sessions} />
        )}
      </FlexColumn>
    </Card>
  );
};

export default UsageCard;
